import type { Delivery } from '@/types/delivery'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { acceptDelivery, type DeliveryForm, getTaskDeliveries, rejectDelivery, submitDelivery } from '@/api/task/delivery'

export const useDeliveryStore = defineStore('delivery-v2', () => {
  const loading = ref(false)
  const deliveries = ref<Delivery[]>([])

  // Getters
  const latestDelivery = computed(() => {
    if (deliveries.value.length === 0)
      return null
    return deliveries.value[deliveries.value.length - 1]
  })

  // Actions
  const fetchDeliveries = async (taskId: string | number) => {
    loading.value = true
    try {
      deliveries.value = await getTaskDeliveries(taskId)
    }
    finally {
      loading.value = false
    }
  }

  const submitDeliveryAction = async (taskId: string | number, data: DeliveryForm) => {
    loading.value = true
    try {
      await submitDelivery(taskId, data)
      await fetchDeliveries(taskId)
    }
    finally {
      loading.value = false
    }
  }

  const acceptDeliveryAction = async (deliveryId: string | number, taskId: string | number) => {
    loading.value = true
    try {
      await acceptDelivery(deliveryId)
      await fetchDeliveries(taskId)
    }
    finally {
      loading.value = false
    }
  }

  const rejectDeliveryAction = async (deliveryId: string | number, reason: string, taskId: string | number) => {
    loading.value = true
    try {
      await rejectDelivery(deliveryId, reason)
      await fetchDeliveries(taskId)
    }
    finally {
      loading.value = false
    }
  }

  return {
    loading,
    deliveries,
    latestDelivery,
    fetchDeliveries,
    submitDelivery: submitDeliveryAction,
    acceptDelivery: acceptDeliveryAction,
    rejectDelivery: rejectDeliveryAction,
  }
})
